import React from 'react'
import { BackgroundBlurCircle } from './components/BackgroundBlurCircle'
import { AuthPage } from './pages/AuthPage'
import './assets/styles/App.sass'

export const App = () => {
  return (
    <div className='App'>
      <AuthPage />
      <BackgroundBlurCircle size={'small'} className='App__circle-left' />
      <BackgroundBlurCircle size={'big'} className='App__circle-right' />
    </div>
  )
}

export default App
